'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainMenu = exports.locales = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _Grid = require('../../../../modules/ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _AppBar = require('material-ui/AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Toolbar = require('material-ui/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _reactRouterDom = require('react-router-dom');

var _User = require('./User');

var _User2 = _interopRequireDefault(_User);

var _styles = require('material-ui/styles');

var _Language = require('../../../Language');

var _Language2 = _interopRequireDefault(_Language);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Modal from './AuthModal';


var styles = exports.styles = function styles(theme) {
  var paletteType = theme.palette.type;
  return {
    root: {// Fix contrast 
      // "& a, & button": {
      //   "&, & *": {
      //     color: paletteType === "light" ? "#fff" : undefined,
      //   },
      // },
    },
    link: {
      color: paletteType === "light" ? "#fff" : undefined
    }
  };
};

var locales = exports.locales = {
  ru: {
    values: {
      Signin: "Вход",
      Signout: "Выход",
      "Main page": "Главная страница",
      "Users": "Пользователи"
    }
  }
};
var MainMenu = exports.MainMenu = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(MainMenu, _PrismaCmsComponent);

  function MainMenu() {
    _classCallCheck(this, MainMenu);

    return _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).apply(this, arguments));
  }

  _createClass(MainMenu, [{
    key: 'logout',
    value: function logout() {
      var logout = this.context.logout;
      logout();
    } // componentWillMount(){
    // }
    // handleClose = () => {
    //   this.setState({
    //     opened: false,
    //   });
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var user = this.context.user;

      _objectDestructuringEmpty(this.state);

      var classes = this.props.classes;

      var _ref = user || {},
          userId = _ref.id,
          sudo = _ref.sudo;

      return _react2.default.createElement(_AppBar2.default // position="relative"
      , {
        className: classes.root,
        style: {
          position: "relative"
        }
      }, _react2.default.createElement(_Grid2.default, {
        container: true,
        spacing: 16,
        alignItems: 'center',
        className: 'MainMenu-root'
      }, _react2.default.createElement(_Grid2.default, {
        item: true
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '/'
      }, _react2.default.createElement(_Typography2.default, {
        component: 'span',
        className: classes.link
      }, this.lexicon("Main page")))), _react2.default.createElement(_Grid2.default, {
        item: true
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '/users'
      }, _react2.default.createElement(_Typography2.default, {
        component: 'span',
        className: classes.link
      }, this.lexicon("Users")))), _react2.default.createElement(_Grid2.default, {
        item: true
      }, _react2.default.createElement('a', {
        href: '/graphql-voyager'
      }, _react2.default.createElement(_Typography2.default, {
        component: 'span',
        className: classes.link
      }, this.lexicon("Graphql Voyager")))), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: true
      }), _react2.default.createElement(_Language2.default, null), user ? [_react2.default.createElement(_Grid2.default, {
        key: 'user',
        item: true
      }, _react2.default.createElement(_User2.default, {
        key: userId,
        user: user,
        classes: classes
      })), _react2.default.createElement(_Grid2.default, {
        key: 'logout',
        item: true
      }, _react2.default.createElement(_Button2.default, {
        onClick: function onClick() {
          return _this2.logout();
        },
        className: classes.link
      }, this.lexicon("Signout")))] : _react2.default.createElement(_Grid2.default, {
        key: 'login',
        item: true
      }, _react2.default.createElement(_Button2.default, {
        onClick: function onClick(e) {
          // this.setState({
          //   opened: true,
          // });
          var openLoginForm = _this2.context.openLoginForm;
          openLoginForm();
        }
      }, _react2.default.createElement(_Typography2.default, {
        component: 'span',
        className: classes.link
      }, this.lexicon("Signin"))))));
    }
  }]);

  return MainMenu;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  locales: locales
}), _temp);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(MainMenu, props);
});